module.exports = __webpack_public_path__ + "static/showroom3-27eb48496b7a5784f89739e2212926e9.jpg";